import { useGetDropboxTokensQuery } from '@account/services';
import { DropboxFolderType } from '@account/types';
import { DropboxDisclaimerDialog } from '@components/display/dialogs';
import { MediaBrowserToolbar } from '@components/display/toolbars';
import { usePublicLayoutOptions } from '@components/layout/public';
import { Button } from '@components/utility/buttons';
import { FirmwaresGridView } from '@firmwares/routes/FirmwaresGridView';
import { FirmwaresListView } from '@firmwares/routes/FirmwaresListView';
import { useAuth } from '@hooks/useAuth';
import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

export const Firmwares = () => {
    const [firmwareDisclaimerOpen, setFirmwareDisclaimerOpen] = useState(false);
    const [params] = useSearchParams();

    const { isLoggedIn } = useAuth();
    const { data: dropboxTokens, isLoading: isLoadingDropboxTokens } = useGetDropboxTokensQuery();
    const hasFirmwares = useMemo(
        () =>
            dropboxTokens?.results.some(
                (token) => token.sync_type === 'firmwares' && token.is_active && !token.is_expired
            ),
        [dropboxTokens]
    );

    const view = params.get('view') === 'list' ? 'list' : 'grid';
    const extraToolbar = useMemo(
        () => (
            <MediaBrowserToolbar
                extraButton={
                    !isLoadingDropboxTokens && !hasFirmwares && isLoggedIn ? (
                        <Button fullRounded onClick={() => setFirmwareDisclaimerOpen(true)} size="small">
                            <FormattedMessage id="firmwares.connectToDropbox" defaultMessage="Connect to Dropbox" />
                        </Button>
                    ) : null
                }
            />
        ),
        [hasFirmwares, isLoadingDropboxTokens]
    );
    usePublicLayoutOptions({ extraToolbar });

    return (
        <>
            <div className="p-[26px] h-full">{view === 'grid' ? <FirmwaresGridView /> : <FirmwaresListView />}</div>;
            <DropboxDisclaimerDialog
                open={firmwareDisclaimerOpen}
                onClose={() => setFirmwareDisclaimerOpen(false)}
                folderType={DropboxFolderType.Firmwares}
            />
        </>
    );
};
